<span class="tr-image d-flex align-items-center justify-content-center" [style.width.rem]="width" [style.height.rem]="height">
  <img src="assets/icons/skeleton/dummy-image.svg" alt="">
</span>